import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CreateSession from './pages/CreateSession';
import GameSession from './pages/GameSession';
import Header from './components/Header';
import { SocketProvider } from './context/SocketContext';
import './App.css';

function App() {
  return (
    <SocketProvider>
      <Router>
        <div className="min-h-screen bg-white">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/create" element={<CreateSession />} />
            <Route path="/session/:id" element={<GameSession />} />
          </Routes>
        </div>
      </Router>
    </SocketProvider>
  );
}

export default App;